import type { Response } from '@frontend/libs/types/common'

import { endpoint } from '@shared/services/endpoint'
import { sendRequest } from '@shared/services/fetcher'
import useSWRMutation from 'swr/mutation'

import type {
  ForgetPasswordState,
  LoginState,
  RegisterState,
  ResetPasswordState,
} from './type'

type AuthResponse = Response<null>

function useAuthMutation<T>(endpoint: string) {
  const {
    data,
    error,
    isMutating: isLoading,
    trigger,
  } = useSWRMutation<AuthResponse, Error, string, T>(endpoint, sendRequest)

  const mutate = async (request: T) => {
    // @ts-expect-error - trigger is not null
    return await trigger(request)
  }

  return { data, error, isLoading, mutate }
}

export function useLogin() {
  return useAuthMutation<LoginState>(endpoint.frontend.AUTH.LOGIN)
}

export function useLogout() {
  return useAuthMutation(endpoint.frontend.AUTH.LOGOUT)
}

export function useRegister() {
  return useAuthMutation<RegisterState>(endpoint.frontend.AUTH.REGISTER)
}

export function useLostPassword() {
  return useAuthMutation<ForgetPasswordState>(
    endpoint.frontend.AUTH.LOST_PASSWORD,
  )
}

export function useResetPassword() {
  return useAuthMutation<ResetPasswordState>(
    endpoint.frontend.AUTH.RESET_PASSWORD,
  )
}
